<template>
  <!--
    Rückmeldung nach dem Zuordnen (Kundenfeedback 18.10.2026, XII/XIII):
    „Hinzugefügt als …“, dann – falls möglich – „Zur Akte einladen“ und bei
    registrierten Treffern ohne Adressbuch-Eintrag die Nachfrage „In Ihre
    Kontakte übernehmen?“ (optional als Favorit).
  -->
  <div class="aac" role="status" data-testid="apd-after-assign">
    <p class="aac__text">
      <strong>{{ entry.name }}</strong> {{ $gt('wurde als') }} <strong>{{ entry.roleLabel }}</strong> {{ $gt('zugeordnet.') }}
      <template v-if="entry.adoptable">{{ $gt('In Ihre Kontakte übernehmen?') }}</template>
    </p>
    <!-- Kundenfeedback 02.11.2026 (I) -->
    <p v-if="entry.invitationBlocked" class="aac__note" data-testid="apd-after-no-invitation">
      {{ $gt('Keine KARS-Einladung versandt: Der Beteiligte möchte keine Einladungen. Bitte informieren Sie ihn auf anderem Weg (z. B. per Post oder E-Mail außerhalb von KARS).') }}
    </p>
    <div class="aac__actions">
      <button
        v-if="entry.invitable"
        type="button"
        class="aac__btn aac__btn--primary"
        :disabled="busy"
        data-testid="apd-after-invite"
        @click="$emit('invite')"
      >{{ $gt('Zur Akte einladen') }}</button>
      <template v-if="entry.adoptable">
        <button type="button" class="aac__btn" :disabled="busy" data-testid="apd-after-adopt" @click="$emit('adopt', false)">{{ $gt('In Kontakte übernehmen') }}</button>
        <button type="button" class="aac__btn" :disabled="busy" data-testid="apd-after-adopt-fav" @click="$emit('adopt', true)">{{ $gt('Als Favorit übernehmen') }}</button>
      </template>
      <button type="button" class="aac__dismiss" :disabled="busy" @click="$emit('dismiss')">{{ entry.invitable || entry.adoptable ? $gt('Nein, danke') : $gt('Ausblenden') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AfterAssignCard",

  props: {
    /** { name, roleLabel, invitable: {id,name,email}|null, adoptable: boolean } */
    entry: { type: Object, required: true },
    busy: { type: Boolean, default: false },
  },

  emits: ["invite", "adopt", "dismiss"],
};
</script>

<style scoped>
.aac {
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px 16px;
  padding: 10px 14px; border-radius: 11px; background: #fff;
  border: 1px solid var(--primary-color); box-shadow: 0 4px 16px rgba(0, 118, 229, .10);
  animation: aac-in var(--duration-normal, 300ms) cubic-bezier(.16, 1, .3, 1);
}
.aac__note { margin: 0; padding: 6px 10px; border-radius: 8px; background: #fff8eb; border: 1px solid #f5c26b; font-size: 12.5px; line-height: 1.45; color: #92400e; }
.aac__text { margin: 0; font-size: 13px; line-height: 1.45; color: var(--dark-color); }
.aac__actions { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.aac__btn {
  height: 30px; padding: 0 12px; border: 1px solid var(--border-grey-color); border-radius: 8px; background: #fff;
  font: inherit; font-size: 12.5px; font-weight: 600; color: var(--dark-color); cursor: pointer;
}
.aac__btn:hover:not(:disabled) { border-color: var(--primary-color); color: var(--primary-color); }
.aac__btn--primary { border-color: var(--primary-color); background: var(--primary-color); color: #fff; }
.aac__btn--primary:hover:not(:disabled) { background: #0a5fc0; color: #fff; }
.aac__btn:disabled, .aac__dismiss:disabled { opacity: .5; cursor: not-allowed; }
.aac__btn:focus-visible, .aac__dismiss:focus-visible { outline: 2px solid var(--primary-color); outline-offset: 2px; }
.aac__dismiss { border: none; background: none; padding: 0 4px; font: inherit; font-size: 12.5px; color: var(--grey-color); cursor: pointer; text-decoration: underline; }
@keyframes aac-in { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: none; } }
@media (prefers-reduced-motion: reduce) { .aac { animation: none; } }
</style>
